var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateBlank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "81px",
    viewBox: "0 0 134 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uq-site-dashboard",
    transform: "translate(-596.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(560.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "template",
    transform: "translate(21.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "template-1",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(15.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EFEFEF",
    x: 0,
    y: 15,
    width: 134,
    height: 66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 134,
    height: 15
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBlank);
export default __webpack_public_path__ + "static/media/template-blank.529a7cdf77c12c15ef1ac49252d46f6c.svg";
export { ForwardRef as ReactComponent };